import { useEffect, type CSSProperties } from "react";

/** ~32 common emojis (incl. a few claims-relevant ones) for the composer. */
const DEFAULT_EMOJIS = [
  "😀", "😁", "😂", "🤣", "😊", "😍", "😘", "😎",
  "🤔", "😅", "😉", "🙂", "🙌", "👍", "👎", "👏",
  "🙏", "💪", "🔥", "🎉", "✅", "❌", "⚠️", "📌",
  "📎", "📞", "🚗", "🌧️", "☀️", "💡", "❤️", "👀",
];

interface EmojiPickerProps {
  onPick: (emoji: string) => void;
  onClose: () => void;
  style?: CSSProperties;
  emojis?: string[];
}

/** A small grid emoji picker with an outside-click + Escape backdrop. */
export function EmojiPicker({ onPick, onClose, style, emojis = DEFAULT_EMOJIS }: EmojiPickerProps) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <>
      <div onClick={onClose} style={{ position: "fixed", inset: 0, zIndex: 5 }} />
      <div
        role="menu"
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(8, 1fr)",
          gap: 2,
          padding: 8,
          width: 300,
          background: "var(--color-panel)",
          border: "1px solid var(--color-border)",
          borderRadius: "var(--radius-md)",
          boxShadow: "var(--shadow-md)",
          ...style,
        }}
      >
        {emojis.map((e) => (
          <button
            key={e}
            type="button"
            onClick={() => {
              onPick(e);
              onClose();
            }}
            style={{
              border: "none",
              background: "transparent",
              cursor: "pointer",
              fontSize: 20,
              lineHeight: 1,
              padding: 4,
              borderRadius: "var(--radius-sm)",
            }}
          >
            {e}
          </button>
        ))}
      </div>
    </>
  );
}
